var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.73436 21.5593C6.44656 21.5588 6.16385 21.4833 5.91405 21.3404C5.35155 21.0216 5.00186 20.4029 5.00186 19.7312V6.13741C5.00186 5.46382 5.35155 4.84694 5.91405 4.52819C6.1698 4.38121 6.46034 4.30562 6.75529 4.30933C7.05025 4.31305 7.33879 4.39592 7.59077 4.54929L19.2087 11.5037C19.4509 11.6555 19.6505 11.8663 19.7888 12.1164C19.9272 12.3664 19.9998 12.6476 19.9998 12.9333C19.9998 13.2191 19.9272 13.5003 19.7888 13.7503C19.6505 14.0004 19.4509 14.2112 19.2087 14.363L7.58889 21.3193C7.33103 21.4752 7.03568 21.5581 6.73436 21.5593Z",
    fill: "#E4B104"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.17b8c7ddc52c8d6d7c41cdcfda911566.svg";
export { ForwardRef as ReactComponent };